// extracted by css-extract-rspack-plugin
export default {"imageViewWrapper":"imageViewWrapper-qv3hvB","controlBar":"controlBar-wUWOIl"};